import { useMemo } from "react";
import PropTypes from "prop-types";

const FrameComponent2 = ({
  className = "",
  onlineTuitionsMargin,
  onlineTuitionsFontWeight,
}) => {
  const onlineTuitionsStyle = useMemo(() => {
    return {
      margin: onlineTuitionsMargin,
      fontWeight: onlineTuitionsFontWeight,
    };
  }, [onlineTuitionsMargin, onlineTuitionsFontWeight]);

  return (
    <div
      className={`flex flex-col items-start gap-1.5 text-center text-[40px] text-[#fff] font-['Great_Vibes'] ${className}`}
    >
      <div className="self-stretch rounded-[10px] bg-[#1e1e1e] flex items-start pt-2.5 pb-[23px] pl-7 pr-[21px]">
        <div className="h-[104px] w-[244px] relative rounded-[10px] bg-[#1e1e1e] hidden shrink-0" />
        <div className="flex-1 relative z-[1] shrink-0 mq750:text-[32px] mq450:text-2xl">
          <span>Insta</span>
          <span className="text-[64px] font-black font-['Kumbh_Sans']">ED</span>
        </div>
      </div>
      <div className="flex items-start py-0 pl-[7px] pr-0.5 text-left text-2xl text-[#000] font-['Maven_Pro']">
        <h3
          className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq450:text-[19px]"
          style={onlineTuitionsStyle}
        >
          Online Tuitions | 6-12
        </h3>
      </div>
    </div>
  );
};

FrameComponent2.propTypes = {
  className: PropTypes.string,

  /** Style props */
  onlineTuitionsMargin: PropTypes.string,
  onlineTuitionsFontWeight: PropTypes.string,
};

export default FrameComponent2;
